export default __webpack_public_path__ + "static/media/Cheque.030707d2.svg";